import LegacyChangePasswordBackstopPage from './LegacyChangePasswordBackstopPage';
export default LegacyChangePasswordBackstopPage;
